import React, { createContext, useContext, useEffect, useState } from 'react';
import supabase from '../lib/supabase';

const SupabaseContext = createContext();

export const useSupabase = () => {
  const context = useContext(SupabaseContext);
  if (!context) {
    throw new Error('useSupabase must be used within a SupabaseProvider');
  }
  return context;
};

export const SupabaseProvider = ({ children }) => {
  const [connected, setConnected] = useState(false);
  const [polls, setPolls] = useState(new Map());

  useEffect(() => {
    // Test connection
    const testConnection = async () => {
      try {
        const { data, error } = await supabase.from('polls_sv2024').select('id').limit(1);
        if (!error) {
          setConnected(true);
        }
      } catch (error) {
        console.log('Supabase not connected yet');
      }
    };

    testConnection();

    // Subscribe to poll changes
    const channel = supabase
      .channel('poll-changes')
      .on('postgres_changes', 
        { event: '*', schema: 'public', table: 'polls_sv2024' },
        (payload) => {
          console.log('Poll updated:', payload);
          // Handle real-time updates
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);

  const value = {
    supabase,
    connected,
    polls,
    setPolls
  };

  return (
    <SupabaseContext.Provider value={value}>
      {children}
    </SupabaseContext.Provider>
  );
};